import { useCallback, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getWellnessChecks } from "../../api/wellnessCheck";
import { wellnessChecksKeys } from "./queryKey";
import { WellnessCheck } from "../../api/generated";

export const useWellnessChecks = (answererId: string) => {
    const queryKey = useMemo(
        () => wellnessChecksKeys.answerers(answererId),
        [answererId]
    );
    const queryClient = useQueryClient();

    const { data: wellnessChecks, isLoading } = useQuery({
        queryKey: queryKey,
        queryFn: () => getWellnessChecks(answererId),
        initialData: () => {
            const allWellnessChecks = queryClient.getQueryData<WellnessCheck[]>(
                wellnessChecksKeys.all
            );
            return allWellnessChecks?.filter(
                (wellnessCheck) => wellnessCheck.answererId === answererId
            );
        },
    });

    const clearCache = useCallback(async () => {
        await queryClient.invalidateQueries(queryKey);
    }, [queryClient, queryKey]);

    const hasNewWellnessCheck = useMemo(
        () =>
            wellnessChecks?.some((wellnessCheck) => wellnessCheck.isUnread) ??
            false,
        [wellnessChecks]
    );

    return {
        wellnessChecks: wellnessChecks ?? [],
        isLoading,
        clearCache,
        hasNewWellnessCheck,
    };
};
